<template lang="pug">
  div.user-page
    div.toolbar
      //div.line
        //h1.title Карточка в виде страницы

      div.line
        div.header
          div.tabs
            span(@click="tabView = 'tab1'" :class="activeClass('tab1')") Общие сведения
            span(@click="tabView = 'tab2'" :class="activeClass('tab2')") Файлы
            span(@click="tabView = 'tab3'" :class="activeClass('tab3')") Мои действия
            span(@click="tabView = 'tab4'" :class="activeClass('tab4')") Смена пароля
        //div.parameter.parameter--right
          select.reg-operator
            option Региональный оператор 1
            option Региональный оператор 2
        form.search
          input(type="search" placeholder="")
        div.filter
          button.filter__button(@click="showFilter = !showFilter") Фильтр
        div.actions-panel
          button.actions-panel__button.btn-columns(title="Отобразить столбцы")
          div.filter-popup(style="display: none")
            div.item
              input.checkbox(type="checkbox")
              label 123
            div.item
              button Выбрать все
          //button.actions-panel__button.btn-refresh(title="Актуализация таблицы")
          //button.actions-panel__button.btn-delete(title="Удаление")
          //button.actions-panel__button.btn-add.green(title="Добавление")


    div.toolbar--filter(:class="showFilter ? 'open' : 'close'")
      div.set-date
        label Период:
        input.date(placeholder="дд.мм.гг")
        label -
        input.date(placeholder="дд.мм.гг")
      div.set-filter
        label Показать:
        label.checked
          input.checkbox(type="checkbox" checked)
          span Отредактированные
        label.checked
          input.checkbox(type="checkbox")
          span Созданные
        label.checked
          input.checkbox(type="checkbox")
          span Удаленные


    div.user-content
      div.body-wrapper
        // вкладка ОБЩИЕ СВЕДЕНИЯ
        div(v-show="tabView == 'tab1'")
          div.body.profile
            div.user-info
              div.user-info__photo
                div.user-info__photo-img
                  img(src="~img/user-img.png")
                button.user-info__photo-edit Изменить фото
              div.user-info__full
                div.user-name
                  div.user-surname Иванов
                  span.user-fullname Ростислав Романович
                div.user-post Администратор
                div.user-email ivanov@mirst.com

          div.body
            div.col
              div.col-block
                div.title
                  p Место работы
              div.col-block
                label Организация
                input(value="Организация/ИП")
              div.col-block
                label Должность
                input(value="")
              div.col-block
                label Рабочий телефон / Skype
                input(value="")
              div.col-block
                button.user-button.user-button--warning Выйти


            div.col
              div.col-block
                div.title
                  p Личные данные
              div.col-block
                label Дата рождения
                input.date(placeholder="дд.мм.гггг")
              div.col-block
                label E-mail
                input(value="")
              div.col-block
                label Мобильный телефон
                input(value="")
              div.col-block.buttons
                button.user-button.user-button--cancel Отмена
                button.user-button.user-button--save Сохранить

            div.col




        // вкладка Файлы
        div(v-show="tabView == 'tab2'")
          div.body.body-table
            div.table-choose-panel
              div.table
                table
                  thead
                    tr
                      th Файлы
                      th Дата загрузки
                      th Место загрузки
                  tbody
                    tr
                      td
                        div.file
                          div.file-content
                            div.img
                            div.filename
                              p.name Название документа.pdf
                              p.size 1,9 Мб
                          div.buttons
                            button.row-download
                      td 28.03.17
                        span.time 9:41
                      td Карточка оператора по обращению с отходами ООО Сельхозмаш
                    tr
                      td
                        div.file
                          div.file-content
                            div.img
                            div.filename
                              p.name Название документа.pdf
                              p.size 1,9 Мб
                          div.buttons
                            button.row-download
                      td 28.03.17
                        span.time 9:41
                      td Карточка оператора по обращению с отходами ООО Сельхозмаш
                    tr
                      td
                        div.file
                          div.file-content
                            div.img
                            div.filename
                              p.name Название документа.pdf
                              p.size 1,9 Мб
                          div.buttons
                            button.row-download
                      td 28.03.17
                        span.time 9:41
                      td Карточка оператора по обращению с отходами ООО Сельхозмаш
                    tr
                      td
                        div.file
                          div.file-content
                            div.img
                            div.filename
                              p.name Название документа.pdf
                              p.size 1,9 Мб
                          div.buttons
                            button.row-download
                      td 28.03.17
                        span.time 9:41
                      td Карточка оператора по обращению с отходами ООО Сельхозмаш
                    tr
                      td
                        div.file
                          div.file-content
                            div.img
                            div.filename
                              p.name Название документа.pdf
                              p.size 1,9 Мб
                          div.buttons
                            button.row-download
                      td 28.03.17
                        span.time 9:41
                      td Карточка оператора по обращению с отходами ООО Сельхозмаш
                    tr
                      td
                        div.file
                          div.file-content
                            div.img
                            div.filename
                              p.name Название документа.pdf
                              p.size 1,9 Мб
                          div.buttons
                            button.row-download
                      td 28.03.17
                        span.time 9:41
                      td Карточка оператора по обращению с отходами ООО Сельхозмаш
                    tr
                      td
                        div.file
                          div.file-content
                            div.img
                            div.filename
                              p.name Название документа.pdf
                              p.size 1,9 Мб
                          div.buttons
                            button.row-download
                      td 28.03.17
                        span.time 9:41
                      td Карточка оператора по обращению с отходами ООО Сельхозмаш
                    tr
                      td
                        div.file
                          div.file-content
                            div.img
                            div.filename
                              p.name Название документа.pdf
                              p.size 1,9 Мб
                          div.buttons
                            button.row-download
                      td 28.03.17
                        span.time 9:41
                      td Карточка оператора по обращению с отходами ООО Сельхозмаш
                    tr
                      td
                        div.file
                          div.file-content
                            div.img
                            div.filename
                              p.name Название документа.pdf
                              p.size 1,9 Мб
                          div.buttons
                            button.row-download
                      td 28.03.17
                        span.time 9:41
                      td Карточка оператора по обращению с отходами ООО Сельхозмаш



        // мои действия
        div(v-show="tabView == 'tab3'")
          div.body.body-table
            div.table.table--noborder.table--thin-rows
              table
                thead
                  th
                    div.sortable
                      div Вид действия
                      div.arrows
                        span.up
                        span.down
                  th
                    div.sortable
                      div Дата действия
                      div.arrows
                        span.up
                        span.down
                  th
                    div.sortable
                      div Раздел
                      div.arrows
                        span.up
                        span.down
                  th
                    div.sortable
                      div Объект
                      div.arrows
                        span.up
                        span.down
                tbody
                  tr
                    td
                      span.icon
                      span.user-edit Редактирование
                    td
                      span 28.03.17
                      span.time 9:41
                    td Реестр операторов по обращению с отходами
                    td Карточка операторов по обращению с отходами
                  tr
                    td
                      span.icon
                      span.user-edit Редактирование
                    td
                      span 28.03.17
                      span.time 9:41
                    td Реестр операторов по обращению с отходами
                    td Карточка операторов по обращению с отходами
                  tr
                    td
                      span.icon
                      span.user-edit Редактирование
                    td
                      span 28.03.17
                      span.time 9:41
                    td Реестр операторов по обращению с отходами
                    td Карточка операторов по обращению с отходами
                  tr
                    td
                      span.icon
                      span.user-edit Редактирование
                    td
                      span 28.03.17
                      span.time 9:41
                    td Реестр операторов по обращению с отходами
                    td Карточка операторов по обращению с отходами
                  tr
                    td
                      span.icon
                      span.user-add Создание
                    td
                      span 28.03.17
                      span.time 9:41
                    td Реестр операторов по обращению с отходами
                    td Карточка операторов по обращению с отходами
                  tr
                    td
                      span.icon
                      span.user-add Создание
                    td
                      span 28.03.17
                      span.time 9:41
                    td Реестр операторов по обращению с отходами
                    td Карточка операторов по обращению с отходами
                  tr
                    td
                      span.icon
                      span.user-add Создание
                    td
                      span 28.03.17
                      span.time 9:41
                    td Реестр операторов по обращению с отходами
                    td Карточка операторов по обращению с отходами
                  tr
                    td
                      span.icon
                      span.user-add Создание
                    td
                      span 28.03.17
                      span.time 9:41
                    td Реестр операторов по обращению с отходами
                    td Карточка операторов по обращению с отходами
                  tr
                    td
                      span.icon
                      span.user-add Создание
                    td
                      span 28.03.17
                      span.time 9:41
                    td Реестр операторов по обращению с отходами
                    td Карточка операторов по обращению с отходами
                  tr
                    td
                      span.icon
                      span.user-add Создание
                    td
                      span 28.03.17
                      span.time 9:41
                    td Реестр операторов по обращению с отходами
                    td Карточка операторов по обращению с отходами
                  tr
                    td
                      span.icon
                      span.user-del Удаление
                    td
                      span 28.03.17
                      span.time 9:41
                    td Реестр операторов по обращению с отходами
                    td Карточка операторов по обращению с отходами
                  tr
                    td
                      span.icon
                      span.user-del Удаление
                    td
                      span 28.03.17
                      span.time 9:41
                    td Реестр операторов по обращению с отходами
                    td Карточка операторов по обращению с отходами

          //div.section.section--border.table-part.scroll
            div.section-wrapper
              div.user

          //div.body
            div.col
              div.col-block
                label Лицензия №
                input(value="5555555555555")
              div.col-block
                label От
                input.date.datetimepicker
              div.col-block
                label До
                input.date.datetimepicker
              //div.col-block
                //label
                label.checked
                  input.checkbox(type="checkbox")
                  span Бессрочная
              div.col-block
                label Классы опасности по видам деятельности
                div.table
                  table
                    thead
                      th
                      th I
                      th II
                      th III
                      th IV
                    tbody
                      tr
                        td Сбор
                        td
                          label.checked
                            input.checkbox(type="checkbox" checked)
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                      tr
                        td Транспортирование
                        td
                          label.checked
                            input.checkbox(type="checkbox" checked)
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                      tr
                        td Обезвреживание

                        td
                          label.checked
                            input.checkbox(type="checkbox" checked)
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox" checked)
                            span
                      tr
                        td Обработка
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                      tr
                        td Утилизация
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox" checked)
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                      tr
                        td Хранение
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox" checked)
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                      tr
                        td Захоронение
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span
                        td
                          label.checked
                            input.checkbox(type="checkbox")
                            span


            div.col
              div.col-block
                label Срок действия до
                input(value="Бессрочная")
              div.col-block
                label Прикрепленные файлы
                form.upload-files
                  div.upload
                    div.upload-content
                      div.icon
                      div.info
                        p.blue Перетащите файлы в эту область
                        p Файл не должен превышать 20Мб
                    button.green--text Загрузить
                  div.uploaded
                    label Загруженные файлы
                    div.uploaded-files

                      div.file
                        div.file-content
                          div.img
                          div.filename
                            p.name Название документа.pdf
                            p.size 1,9 Мб
                        div.buttons
                          button.row-delete
                          button.row-download

                      div.file
                        div.file-content
                          div.img
                          div.filename
                            p.name Название документа.pdf
                            p.size 1,9 Мб
                        div.buttons
                          button.row-delete
                          button.row-download

            div.col

        // смена пароля
        div(v-show="tabView == 'tab4'")
          div.body
            div.col
              div.col-block
                label Старый пароль *
                input.error(type="password" value="111111")
                span.error Пароль не верен
              div.col-block
                label Новый пароль *
                input(type="password" value="111111")

              div.col-block
                label Повторите пароль *
                input(type="password" value="111111")
                span.error Пароли не совпадают
              div.col-block.buttons
                button.user-button.user-button--cancel Отмена
                button.user-button.user-button--save Сохранить

            div.col
            div.col






    //div.footer-nav
      div.actions-filter-panel
        button.actions-filter-panel__button.default.download Скачать
      //div.paginator
        span Показывать по
        select
          option 10
          option 25
          option 50
          option 100
        div.page-nav
          span.navigate.prev
          input(type='text')
          span из ?
          span.navigate.next

    //div.footer
      div.actions-filter-panel
        button.actions-filter-panel__button.standart.standart-delete Удалить
        div
          button.actions-filter-panel__button.standart.standart-noborder Отмена
          button.actions-filter-panel__button.standart Сохранить


</template>

<script>
  import editButtons from './tables-component/partials/garbageEditButtons.vue';
  import expandRow from './tables-component/AtuExpandRow.vue';

  export default {
    data() {
      return {
        tabView: 'tab3',
        select1: false,
        select1_tabs: 'tab1',
        showList: false,
        showList2: false,
        showFilter: true
      };
    },
    methods: {
      activeClass(tab) {
        if (tab === this.tabView) {
          return 'active';
        }
        return '';
      }
    },
    components: {
      editButtons, expandRow
    }
  };
</script>


<style lang="scss">
  /*@import "./../../../assets/styles/fixedColRowTable";*/

  /* закоментил  */
  /* @import "./../../../assets/styles/cardPage"; */
</style>
